import React from "react";
import "./styles.scss";
import { useNavigate } from "react-router-dom";

import Button from "../../../common/button";

const SafetySection = ({ data }) => {
  const Navigate = useNavigate();
  const { button_text, solutions } = data;
  return (
    <div className="safety-container">
      <div className="btn">
        {button_text && (
          <Button
            onClick={() => Navigate(`${process.env.REACT_APP_BASE}/risk-fall`)}
          >
            {button_text}
          </Button>
        )}
      </div>
      <p className="title">Room Solutions</p>
      <div className="sub-container">
        {solutions?.map((item, index) => {
          return (
            <div key={index} className="section">
              <h3>{item?.title}</h3>
              <p dangerouslySetInnerHTML={{ __html: item?.description }} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SafetySection;
